<template lang="html">
   <div class="upload-alerts" v-show="notifications.length > 0">
      <UploadAlert v-for="notification in notifications"
         :name="notification.name"
         :key="notification.id"
         :total="notification.total"
         :current="notification.current"
         :progress="notification.progress"/>
   </div>
</template>

<script>
   export default {
      components:{
         UploadAlert: () => import('./uploadAlert')
      },
      created(){
         this.utils = utils
         
         Event.$on("upload_notification:create", async (payload) => {
            this.notifications.push({
               id: payload.id,
               name: payload.name,
               current: '0 Bytes',
               total: '0 Bytes',
               progress: 0,
            })
         });

         Event.$on("upload_notification:progress", (payload) => {
            for (let i = 0; i < this.notifications.length; i++) {
               const notification = this.notifications[i];
               
               if(notification.id === payload.id){
                  console.log('Found')
                  notification.current = payload.current
                  notification.total = payload.total
                  notification.progress = payload.progress
                  break;
               }
            }
         });

         Event.$on("upload_notification:complete", (payload) => {
            this.closeNotification(payload.id)
         });

         // Event.$on("upload_notification:aborted", (payload) => {
         // });

         // Event.$on("upload_notification:error", (payload) => {
         // });
      },
      data () {
         return {
            notifications: [],
            utils: {}
         }
      },
      methods: {
         closeNotification (id) {
            let $this = this

            for (let i = 0; i < $this.notifications.length; i++) {
               const notification = $this.notifications[i];

               if(notification.id === id){
                  // TODO: update the icon to a check
                  setTimeout(() => {
                     $this.notifications.splice(i, 1);
                  }, 3000);
                  break;
               }
            }
         },
      },
   }
</script>

<style lang="scss">
   .upload-alerts{
      position: fixed;
      left: 10px;
      bottom: 15px;
      z-index: 1499;
      // overflow-y: scroll;
      max-width: 98vw;
      width: auto;
   }
</style>